import { Context, type Effect, Layer, type Option, type Scope } from "effect";
import type { EditorLanguageFailure, EditorLanguageHover, EditorLanguageLibraries, EditorLanguageRequest } from "./language-model.ts";
export interface EditorLanguageSession {
  readonly authority: string;
  readonly languageFor: (filename: string) => string | undefined;
  readonly synchronize: (uris: readonly string[]) => Effect.Effect<void, EditorLanguageFailure>;
  readonly read: (uri: string) => Effect.Effect<Option.Option<string>, EditorLanguageFailure>;
  readonly hover: (uri: string, offset: number) => Effect.Effect<Option.Option<EditorLanguageHover>, EditorLanguageFailure>;
  readonly updateLibraries: (libraries: EditorLanguageLibraries) => Effect.Effect<void, EditorLanguageFailure>;
}
export class EditorLanguageIo extends Context.Service<EditorLanguageIo, {
  readonly acquire: (request: EditorLanguageRequest) => Effect.Effect<EditorLanguageSession, EditorLanguageFailure, Scope.Scope>;
}>()("workerstation/frontend/EditorLanguageIo") {
}
export const EditorLanguageIoTest = (ports: typeof EditorLanguageIo.Service) => Layer.succeed(EditorLanguageIo, ports);
